import { images } from "../constants";

const gallery = [
    {
        image: images.gallery1,
        title: 'Tre Cime di Lavaredo',
    },
    {
        image: images.gallery2,
        title: 'Punta Cana',
    },
    {
        image: images.gallery3,
        title: 'Summer Palace',
    },
    {
        image: images.gallery4,
        title: 'alpine lake',
    },
    {
        image: images.gallery5,
        title: 'Santorini, Greece',
    },
];

export default gallery;